// src/json/parse.ts
var safeParseJson = (json) => {
  try {
    return JSON.parse(json);
  } catch {
    return json;
  }
};

export {
  safeParseJson
};
//# sourceMappingURL=chunk-3L7ZBNA4.mjs.map